module.exports = __webpack_public_path__ + "img/logo.9b7257f5.svg";